import React from "react";
import { connect } from "react-redux";

import SubHeader from "./SubHeader";
import FormInput from "../forms/FormInput";
import { setLoading } from "../../actions/authAction";
import history from "../../history";
import api from "../../api/api";
import uri from "../../variables/uri";
import util from "../../functions/Utilities";
import FormSelectWithAdd from '../forms/FormSelectWithAdd';
import FormSuggestUserWithAdd from '../forms/FormSuggestUserWithAdd';
import AlertModal from '../modals/AlertModal';
import groupImg from '../../images/group.png';

class GroupDetail extends React.Component{
    state = {
        user: this.props.user,
        isOpenMessage: false,
        type:1,
        message: "",
        text: "",
        checkedAdmin:false,
        //Group
        groupId: null,
        groupName: "",
        groupActive: false,
        //Permission
        permissionList:[],
        //Book
        bookArr:[],
        bookList:[],
        bookGroupList:[],
        bookSelected:{},
        bookName:"",
        //User
        userGroupList:[],
        userName:"",
        userIdSelected:""

      };

    componentDidMount = async () => {
        if (!this.props.auth.isAuthen || (!this.props.auth.isAdmin && !this.props.auth.isEditor && !this.props.auth.isApprover)) {
            history.push("/");
        } else {
            //this.props.match.params.groupId
            try {
                this.props.setLoading(true);
                const response = await api.get(`${uri.GET_GROUP_DETAIL}?id=${this.props.match.params.groupId}`);
                this.getPermissionGroup();
                this.getBook();
                this.getBookGroup();
                this.getUserGroup();
                if(response.status === 200) {
                    this.setState({groupId:response.data.ID, groupName: response.data.Name, groupActive: response.data.Active});
                    this.props.setLoading(false);
                };
            } catch (ex) {
                this.props.setLoading(false);
                this.setState({groupId:null, groupName: "", groupActive: false});
                //alert
            }
        }
    };

    onClose = () =>{
        this.setState({ isOpenDetail: false, isOpenMessage: false});
    }

    //Group
    onGroupNameChange = (value)=>{
        this.setState({groupName: value});
    }

    onGroupActiveChange = (e)=>{
        this.setState({groupActive: e.target.checked});
    }

    onGroupSave = async ()=>{
        try {
            this.props.setLoading(true);
            const response = await api.post(`${uri.POST_UPDATE_GROUP}`,{
                ID: this.state.groupId,
                Name: this.state.groupName,
                Active: this.state.groupActive
            });
            if(response.status === 200) {
                this.props.setLoading(false);
                this.setState({ isOpenMessage: true,message:"The data was saved successfully.",type:1});
            };
        } catch (ex) {
            this.props.setLoading(false);
            this.setState({ isOpenMessage: true,message:"An error has occurred.",type:3});
        }
    }

    //Permission
    getPermissionGroup = async ()=>{
        try{
            const response = await api.get(`${uri.GET_PERMISSION_GROUP}?id=${this.props.match.params.groupId}`);
            if(response.status === 200) {
                this.setState({permissionList: response.data});
                this.checkAdmin();
            };
        }catch(ex){
            this.setState({permissionList:[]});
            this.setState({ isOpenMessage: true,message:"An error has occurred.",type:3});
            this.checkAdmin();
        }
        
    }
    onCheckboxPermissionChange = (e,key)=>{
        let checkedList =[];
        let newCheckedList = this.state.permissionList.map(obj => {
            if(obj.PermissionID === key){
                obj.IsChecked = e.target.checked
                if(obj.IsChecked === true){
                checkedList.push(obj.RequestID);
                }
                return obj
            }else{
                if(obj.IsChecked === true){
                checkedList.push(obj.RequestID);
                }
                return obj
            }
        });
        this.setState({permissionList:newCheckedList});
    }

    onPermissionSave = async ()=>{
        try {
            this.props.setLoading(true);
            const response = await api.post(`${uri.POST_UPDATE_PERMISSION_GROUP}`,this.state.permissionList);
            if(response.status === 200) {
                this.setState({ isOpenMessage: true,message:"The data was saved successfully.",type:1});
                this.checkAdmin();
                this.getBookGroup();
                this.props.setLoading(false);
            };
        } catch (ex) {
            this.setState({ isOpenMessage: true,message:"An error has occurred.",type:3});
            this.checkAdmin();
            this.getBookGroup();
            this.props.setLoading(false);
        }
    }

    //Book
    getBook= async ()=>{
        try{
            const booklistResponse = await api.get(uri.GET_BOOK_LIST);
            if(booklistResponse.status === 200){
                const bookArr = ["--เลือกเล่ม--"];
                bookArr.push('All');
                booklistResponse.data.forEach((item) => {
                    bookArr.push(item.BookName);
                });
                this.setState({
                    bookArr: bookArr,
                    bookList: booklistResponse.data,
                });
            }
        }catch(ex){
            this.setState({ isOpenMessage: true,message:"An error has occurred.",type:3});
        }
    }
    getBookGroup = async ()=>{
        try{
            const booklistResponse = await api.get(`${uri.GET_BOOK_GROUP}?id=${this.props.match.params.groupId}`);
            if(booklistResponse.status === 200){
                this.setState({
                    bookGroupList: booklistResponse.data,
                });
            }
        }catch(ex){
            this.setState({ isOpenMessage: true,message:"An error has occurred.",type:3});
        }
    }

    onBookChange = (book)=>{
        const found = this.state.bookList.find(
            (item) => item.BookName === util.validateBookName(book)
          );
        try{
            this.setState({
                bookSelected: found,
                bookName: book
            });
        }catch(ex){
            this.setState({ isOpenMessage: true,message:"An error has occurred.",type:3});
        }
    }

    onBookSave = async () =>{
        if(this.state.bookName==="All" || (this.state.bookSelected !== undefined && this.state.bookName!=="")){
            try{
                this.props.setLoading(true);
                const response = await api.post(`${uri.POST_ADD_BOOK_GROUP}`,{
                    GroupID:this.state.groupId,
                    BookCode: this.state.bookName==="All"?"all":this.state.bookSelected.BookCode
                });
                if(response.status === 200) {
                    this.props.setLoading(false);
                    this.setState({ isOpenMessage: true,message:"The data was saved successfully.",type:1});
                    this.getBookGroup();
                };
                
            }catch(ex){
                this.setState({ isOpenMessage: true,message:"An error has occurred.",type:3});
                this.props.setLoading(false);
            }
        }else{
            this.setState({ isOpenMessage: true,message:"Please select book.",type:2});
        }
        
    }

    onBookDelete = async (code) =>{
        try{
            this.props.setLoading(true);
            const response = await api.post(`${uri.POST_DELETE_BOOK_GROUP}`,{
                GroupID:this.state.groupId,
                BookCode: code
            });
            if(response.status === 200) {
                this.props.setLoading(false);
                this.setState({ isOpenMessage: true,message:"The data has been deleted.",type:1});
                this.getBookGroup();
            };
            
        }catch(ex){
            this.props.setLoading(false);
            this.setState({ isOpenMessage: true,message:"An error has occurred.",type:3});
        }
    }

    //User
    onHandleSelect = async (value) => {
        if (value === undefined) {
            this.setState({ userName:"", userIdSelected:""});
        } else {
            this.setState({ userName: `${value.FirstNameEN} ${value.LastNameEN}`,userIdSelected:value.UserID });
        }
    }

    getUserGroup= async()=>{
        try{
            const listResponse = await api.get(`${uri.GET_USER_GROUP}?id=${this.props.match.params.groupId}`);
            if(listResponse.status === 200){
                this.setState({
                    userGroupList: listResponse.data,
                });
            }
        }catch(ex){
            this.setState({ isOpenMessage: true,message:"An error has occurred.",type:3});
        }
    }

    onUserGroupSave = async()=>{
        if(this.state.userName !== "" && this.state.userIdSelected !== undefined){
            try{
                this.props.setLoading(true);
                const response = await api.post(`${uri.POST_ADD_USER_GROUP}`,{
                    GroupID:this.state.groupId,
                    UserID: this.state.userIdSelected
                });
                if(response.status === 200) {
                    this.props.setLoading(false);
                    this.setState({ isOpenMessage: true,message:"The data was saved successfully.",type:1});
                    this.getUserGroup();
                };
                
            }catch(ex){
                this.setState({ isOpenMessage: true,message:"An error has occurred.",type:3});
                this.props.setLoading(false);
            }
        }else{
            this.setState({ isOpenMessage: true,message:"Please select User",type:2});
        }
    }

    onUserGroupDelete = async (id) =>{
        try{
            this.props.setLoading(true);
            const response = await api.post(`${uri.POST_DELETE_USER_GROUP}`,{
                GroupID:this.state.groupId,
                UserID: id
            });
            if(response.status === 200) {
                this.props.setLoading(false);
                this.setState({ isOpenMessage: true,message:"The data has been deleted.",type:1});
                this.getUserGroup();
            };
            
        }catch(ex){
            this.props.setLoading(false);
            this.setState({ isOpenMessage: true,message:"An error has occurred.",type:3});
        }
    }

    checkAdmin(){
       
        const permis = this.state.permissionList.find((item) => item.PermissionCode === "editor" && item.IsChecked === true);
        if(permis!==undefined){
            this.setState({checkedAdmin:false});
        }else{
            this.setState({checkedAdmin:true});
        }
        // this.state.permissionList.map((item)=>{
        //     if((item.PermissionCode === "admin" || item.PermissionCode === "approver") && item.IsChecked === true){
        //         this.setState({checkedAdmin:true});
        //     }
        // })
    }
    render(){
        return(
            <div className="home flex-v">
                <div className="flex-v flex-1">
                    <SubHeader text="Manage Group" />
                    <div className="flex-v">
                        <div className="flex-h mt-16 ml-24" style={{ alignItems: 'center' }}>
                            <img src={groupImg} alt="" style={{ height: '25px' }} />
                            <h3 className="ml-16 text-center">Group</h3>
                        </div>
                        <div className="flex-v card ml-16 mr-16 p-16 pt-0">
                            <FormInput
                                name="Group name"
                                value={this.state.groupName}
                                onValueChange={this.onGroupNameChange}
                                />
                            <div className="flex-v mt-16">
                                <label className="font-12">Active: <input className="ml-8 button-edit-small" onChange={(e) => this.onGroupActiveChange(e)} type="checkbox" checked={this.state.groupActive} /></label>
                            </div>
                            <div className="flex-v mt-16">
                                <button onClick={() => this.onGroupSave()} className="button is-success center" >
                                    Save
                                </button>    
                            </div>
                        </div>
                        <div className="flex-h mt-16 ml-24" style={{ alignItems: 'center' }}>
                            <img src={groupImg} alt="" style={{ height: '25px' }} />
                            <h3 className="ml-16 text-center">Role</h3>
                        </div>
                        <div className="flex-v card ml-16 mr-16 p-16 pt-0">
                            {this.state.permissionList.map((item,i)=>{
                                return (
                                    <div key={item.PermissionID} className="flex-v mt-16">
                                        <label className="font-12"><input className="ml-8 button-edit-small" onChange={(e) => this.onCheckboxPermissionChange(e,item.PermissionID)} type="checkbox" checked={item.IsChecked} /> {item.PermissionName}</label>
                                    </div>
                                );
                            })}
                            <div className="flex-v mt-16">
                                <button onClick={() => this.onPermissionSave()} className="button is-success center" >
                                Save
                                </button>    
                            </div>
                        </div>
                        {!this.state.checkedAdmin && <div className="flex-h mt-16 ml-24" style={{ alignItems: 'center' }}>
                            <img src={groupImg} alt="" style={{ height: '25px' }} />
                            <h3 className="ml-16 text-center">Book</h3>
                        </div>}
                        {!this.state.checkedAdmin && <div className="flex-v card ml-16 mr-16 p-16 pt-0">
                            <div className="flex-v mt-16">
                                <FormSelectWithAdd
                                    add={this.onBookSave}
                                    value={this.state.bookName}
                                    options={this.state.bookArr}
                                    onValueChange={this.onBookChange}
                                    />
                            </div>
                            <div className="flex-v mt-16">
                                <div className="table-container">
                                    <table className="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
                                        <thead>
                                            <tr>
                                                <th>
                                                    Name
                                                </th>
                                                <th>
                                                    Action
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.bookGroupList.map((item, i) =>{
                                                    return (
                                                        <tr key={item.ID}>
                                                            <td>
                                                                {item.BookName}
                                                            </td>
                                                            <td>
                                                                <button onClick={() => this.onBookDelete(item.BookCode)} className="button is-small is-danger is-outlined">delete</button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>}
                        <div className="flex-h mt-16 ml-24" style={{ alignItems: 'center' }}>
                            <img src={groupImg} alt="" style={{ height: '25px' }} />
                            <h3 className="ml-16 text-center">User</h3>
                        </div>
                        <div className="flex-v card ml-16 mr-16 p-16 pt-0">
                            <div className="flex-v mt-16">
                                <FormSuggestUserWithAdd
                                        name="Name / Email"
                                        handleSelect={this.onHandleSelect}
                                        value={this.state.userName}
                                        add={this.onUserGroupSave}
                                        />
                                
                            </div>
                            <div className="flex-v mt-16">
                                <div className="table-container">
                                    <table className="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
                                        <thead>
                                            <tr>
                                                <th>
                                                    Name
                                                </th>
                                                <th>
                                                    Action
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.userGroupList.map((item, i) =>{
                                                    return (
                                                        <tr key={item.ID}>
                                                            <td>
                                                                {item.FullName}
                                                            </td>
                                                            <td>
                                                                <button onClick={() => this.onUserGroupDelete(item.UserID)} className="button is-small is-danger is-outlined">delete</button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <AlertModal isOpen={this.state.isOpenMessage} message={this.state.message} onClose={this.onClose} type={this.state.type} />
            </div>
        );
    }


}

const mapStateToProps = (state) => {
    return {
      auth: state.auth,
      user: state.doa.user,
    };
  };
  
  export default connect(mapStateToProps, {
    setLoading,
  })(GroupDetail);